import { useState, useEffect } from 'react'

import useAxiosPrivate from '../../../hooks/useAxiosPrivate'
import useAuth from '../../../hooks/useAuth'

import Contact from '../../../components/Contact'
import PPQDashboard from './PPQDashboard'
import OHDashboard from './OHDashboard'

const Dashboard = () => {
  const axios = useAxiosPrivate()
  const { auth } = useAuth()
  const [serviceType, setServiceType] = useState('ppq')

  const [previousPolicy, setPreviousPolicy] = useState(false)
  const [orgInfo, setOrgInfo] = useState('')

  const [availableSchools, setAvailableSchools] = useState({
    ppq: { current: [], previous: [] },
    oh: { current: [], previous: [] },
  })

  const [counts, setCounts] = useState({
    ppq: { current: 0, previous: 0 },
    oh: { current: 0, previous: 0 },
  })

  useEffect(() => {
    try {
      if (auth?.currentPolicy) {
        setOrgInfo(JSON.parse(localStorage.getItem('orgType')))
        getPreviousPolicy()

        fetchSchoolsAndCounts()

        // Ensure serviceType is PPQ if OH requests are not available
        if (!auth?.currentPolicy?.oha_requests && serviceType === 'oh') {
          setServiceType('ppq')
        }
      }
    } catch (error) {
      console.error('Error in Dashboard useEffect:', error)
    }
  }, [auth, serviceType])

  const fetchSchoolsAndCounts = async () => {
    const data = {
      'currentPolicy': auth?.currentPolicy?.policy_id,
      'previousPolicy': previousPolicy?.policy_id,
      'contactId': auth.user.contact_id,
      'masterOh': auth.user.master_oh,
    }

    const response = await axios.post('/service-requests/available-schools', data)

    if (response.status !== 200 || response.data.error === true) {
      console.error('Error fetching available schools:', response.data.message)
      return
    }

    setAvailableSchools({
      ppq: {
        current: response.data.ppq_schools?.current || [],
        previous: response.data.ppq_schools?.previous || []
      },
      oh: {
        current: response.data.oh_schools?.current || [],
        previous: response.data.oh_schools?.previous || []
      }
    })

    console.log('Fetched available schools:', response.data)

    setCounts({
      ppq: {
        current: response.data.ppq_counts?.current || 0,
        all: response.data.ppq_counts?.all || 0,
        previous: {
          current: response.data.ppq_counts?.previous.current || 0,
          all: response.data.ppq_counts?.previous.all || 0
        }
      },
      oh: {
        current: response.data.oh_counts?.current || 0,
        all: response.data.oh_counts?.all || 0,
        previous: {
          current: response.data.oh_counts?.previous.current || 0,
          all: response.data.oh_counts?.previous.all || 0
        }
      }
    })
  }

  const getPreviousPolicy = async () => {
    try {
      const response = await axios.post('/staff-hub/previous-policy', {
        token: auth.token,
        orgId: auth.schools[0].id ?? auth?.schools[0].id,
        user: auth?.user?.contact_id,
      })

      if (response.data.error !== true) {
        setPreviousPolicy(response.data.result?.data.policy)
      } else {
        console.error('Error in response:', response.data.message)
      }
    } catch (error) {
      console.error('Error fetching previous policy:', error)
    }
  }

  return (
    <div>
      <div className="mb-8 sm:mb-10">
        <h3 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white text-center pt-12">
          {serviceType === 'ppq' ? 'Pre-Placement Questionnaires (PPQ)' : 'Occupational Health Requests'}
        </h3>
        <h4 className="text-lg font-medium text-white text-center">
          {serviceType === 'ppq'
            ? 'Create and Manage your Pre-Placement Questionnaire Requests here.'
            : 'Create and Manage your Occupational Health Requests here.'}
        </h4>
      </div>

      {/* Service Type Toggle */}
      {!!auth?.currentPolicy?.oha_requests && (
        <div className="flex justify-center mb-6">
          <div className="flex bg-gray-100 rounded-lg shadow-md overflow-hidden">
            <button
              className={`px-6 py-3 font-medium transition-colors ${serviceType === 'ppq'
                ? 'bg-white text-[#02ADAD] shadow-sm'
                : 'bg-transparent text-gray-700 hover:bg-gray-50'
                }`}
              onClick={() => setServiceType('ppq')}
            >
              Pre-Placement Questionnaires
            </button>
            <button
              className={`px-6 py-3 font-medium transition-colors ${serviceType === 'oh'
                ? 'bg-white text-[#02ADAD] shadow-sm'
                : 'bg-transparent text-gray-700 hover:bg-gray-50'
                }`}
              onClick={() => setServiceType('oh')}
            >
              Occupational Health
            </button>
          </div>
        </div>
      )}

      {serviceType === 'ppq' ? (
        <PPQDashboard
          previousPolicy={previousPolicy}
          orgInfo={orgInfo}
          availableSchools={availableSchools.ppq}
          counts={counts.ppq}
        />
      ) : (
        !!auth?.currentPolicy?.oha_requests && (
          <OHDashboard
            previousPolicy={previousPolicy}
            orgInfo={orgInfo}
            availableSchools={availableSchools.oh}
            counts={counts.oh}
          />
        )
      )}

      <div className="rounded-md bg-[#FFECD1] p-4 mt-16 border border-[#F8CF94]">
        <div className="flex">
          <div className="flex-shrink-0">
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-[#B57B29]">
              <strong>Please Note:</strong> All wellbeing service requests are
              confidential. Therefore any requests for access made by them will
              not show below. Presented here are the {serviceType === 'ppq' ? 'Pre-Placement Questionnaires' : 'Occupational Health Requests'} created by you.
            </p>
          </div>
        </div>
      </div>

      <Contact />
    </div>
  )
}

export default Dashboard
